
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
} from "@/components/ui/dialog";
import {
  EnhancedDialogContent,
  EnhancedDialogTitle,
  EnhancedDialogDescription
} from '@/lib/shadcn-wrappers';

interface DialogInfoProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const DialogInfo = ({ open, onOpenChange }: DialogInfoProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <EnhancedDialogContent>
        <DialogHeader>
          <EnhancedDialogTitle>Om Kai</EnhancedDialogTitle>
          <EnhancedDialogDescription>
            Kai er vår kunstige intelligens journalist som kan hjelpe deg å forstå og analysere intervjuene. Den kan svare på spørsmål, forklare tekniske konsepter, og gi innsikt i intervjuobjektenes erfaringer og synspunkter.
          </EnhancedDialogDescription>
        </DialogHeader>
      </EnhancedDialogContent>
    </Dialog>
  );
};

export default DialogInfo;
